module.exports = __webpack_public_path__ + "img/spirit_pc.fc5bbc86.webp";